import axios from 'axios';
const BASE_URL = 'https://linglingli.ca';

const axiosInstance =  axios.create({
    withCredentials: true,
    baseURL: BASE_URL
});

const axiosInstancePrivate = axios.create({
    baseURL: BASE_URL
});

export {axiosInstance, axiosInstancePrivate};